import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "appeal/";

// 我的申诉 - 列表
export const appealPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };

// 我的申诉 - 添加
export const appealAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};
// 我的申诉 - 删除
export const appealRemove = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + `remove/${params.id}`, {
    method: "DELETE",
  });
}; 

// 我的申诉 - 详情
export const appealView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/appeal.js